import './lib/perf/perfArms';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './i18n.ts';
// Sentry se inicializa automáticamente al importar el módulo
import { sentry } from './sentry/sentry.singleton.ts';
import { setSentryReplayModeReader } from './lib/perf/perfContext';
import { startInteractionObserver } from './lib/perf/interactionObserver';
import { startReloadClassifier } from './lib/perf/reloadClassifier';
// Import design system styles BEFORE app styles
// Tokens del DS (paleta, spacing, tipografía, etc.) — fuente real desde 1.7.0 (DES-129)
import '@leadsales/design-system/tokens';
// Tokens propios del front que el DS no publica: alertas RET-1269, tap targets, bc-muted
import './styles/ls-tokens.css';
import '@leadsales/design-system/react/styles.css';
import './styles/main.scss';

setSentryReplayModeReader(() => sentry.getReplay()?.getRecordingMode());
startReloadClassifier();
startInteractionObserver();

function render() {
  ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
}

// Wallet endpoints do not exist yet (RET-1756), INT-1538's undelivered card
// is walked locally before its backend reaches staging, and Directory v2 is
// walked before its flag can be set on staging. In a dev build with
// VITE_MOCK_WALLET, VITE_MOCK_UNDELIVERED or VITE_MOCK_DIRECTORY_V2 set to
// true, start MSW before rendering so the first request is already
// intercepted. Every condition is statically false in a production build, so
// this branch and its imports are dropped from the bundle.
if (
  import.meta.env.DEV &&
  (import.meta.env.VITE_MOCK_WALLET === 'true' ||
    import.meta.env.VITE_MOCK_UNDELIVERED === 'true' ||
    import.meta.env.VITE_MOCK_DIRECTORY_V2 === 'true')
) {
  import('./mocks/browser').then(({ startDevMocks }) =>
    startDevMocks().then(render),
  );
} else {
  render();
}
